module.exports = __webpack_public_path__ + "static/media/footerLettersBlue.5ea55b9a.svg";